module.exports = __webpack_public_path__ + "img/horizontal_3_6_9005.e40b8065.png";